import React, { useEffect, useState } from "react";
import Input from "antd/es/input/Input";
import { Button, message } from "antd";
import axios from "axios";
import { getDocFileBase64 } from "../../apis/SummarySheetAPI";
import { useDispatch, useSelector } from "react-redux";
import { useLocation } from "react-router-dom";
import {getTitleFromPath} from "../../libs/utilities/helpers/getTitle"
const SummarySheet = () => {
    const dispatch = useDispatch();
    const [srNumber, setSrNumber] = useState("");
    
    // Regular expression to match HTML tags (e.g., <script>, <div>, etc.)
    const location = useLocation();
    const htmlTagRegex = /<\/?[\w\s]*>|<.*?>/g;

    const handleFolderName = (e) => {
        setSrNumber(e.target.value);
    };

    const handleDownload = async (filename) => {
        // Check if input contains HTML tags
        if (htmlTagRegex.test(srNumber)) {
            message.error("Invalid input");
            return;
        }

        // Proceed with the API call if no HTML tags found
        try {
            if (srNumber === '' || srNumber === undefined || srNumber === null) {
                message.error("Please enter a valid SR number");
            } else {
                const response = await dispatch(getDocFileBase64({ srNumber }));
                if (response.error) {
                    if (response.error.statusCode === 'ERR0046') {
                        message.error("Please enter a valid SR number");
                    }
                }else if(response?.payload?.statusCode == 200 && response?.payload?.data?.data == null){
                    message.error("No data exist for this SR number");
                }else {                                        
                    const binaryData = atob(response.payload.data.data); // Decode the Base64 string to binary data
                    const arrayBuffer = new ArrayBuffer(binaryData.length);
                    const uint8Array = new Uint8Array(arrayBuffer);
                    for (let i = 0; i < binaryData.length; i++) {
                        uint8Array[i] = binaryData.charCodeAt(i);
                    }

                    // Create a Blob with the binary data and the correct MIME type for .docx
                    const blob = new Blob([uint8Array], { type: 'application/vnd.openxmlformats-officedocument.wordprocessingml.document' });
                    // Create a temporary link element to trigger the download
                    const link = document.createElement('a');
                    link.href = URL.createObjectURL(blob);
                    link.download = srNumber; // File name for the download
                    link.click();
                    setSrNumber("");
                }
            }
        } catch (error) {
            console.error("Error downloading file", error);
        }
    };

    return (
        <>
        <div className="heading-div">
        <p className="text5">
          {getTitleFromPath(location ?.pathname)}
        </p>
      </div>
            <div style={{ padding: "20px", display: "grid" }}>
                <Input
                    value={srNumber}
                    onChange={handleFolderName}
                    style={{ width: "70%", height: "50px", marginBottom: "10px" }}
                    placeholder="Please enter SR number like 1-123456789123"
                />

                <Button type="primary" onClick={handleDownload}
                    style={{ width: "10%" }} >
                    <div className=''>Search</div>
                </Button>
            </div>
        </>
    );
};

export default SummarySheet;
